const setNewBlockNewTree = (newTree, newBlock, store, setBlocksAction) => {
  newTree[newBlock.id] = newBlock;
  store.dispatch(setBlocksAction(newTree));
};

export default setNewBlockNewTree;
